import {
  GET_CONTACT_RESEARCH_REQUEST,
  GET_CONTACT_RESEARCH_SUCCESS,
  GET_CONTACT_RESEARCH_FAILURE,
  RESET_CONTACT,
  statusType
} from '../../../actions'

const initial = {
  data: [],
  total: 0,
  status: statusType.IDLE
}

const research = (state = initial, action) => {
  const { payload, meta } = action

  switch (action.type) {
    case GET_CONTACT_RESEARCH_REQUEST:
      return {
        ...state,
        status: statusType.IN_PROGRESS
      }

    case GET_CONTACT_RESEARCH_SUCCESS:
      return {
        ...state,
        data: payload,
        total: meta && meta.total,
        status: statusType.SUCCESS
      }

    case GET_CONTACT_RESEARCH_FAILURE:
      return {
        ...state,
        status: statusType.ERROR
      }

    case RESET_CONTACT:
      return {
        ...initial
      }

    default:
      return state
  }
}

export default research
